export default function getHashUrl(url: string): string {
  // return `${url}?${__APP_HASH__}`// fuck you
  return `${url}?112233`
}
